import { required, optional } from 'AppReact/schema';
import uuidv4 from 'uuid-browser/v4';

export default {
    id: optional('integer'),
    name:required('string'),
    type: required('string'),
    breed: required('string'),
    weight: required('string'),

    hasError: optional('boolean'),
    nameError:optional('string'),
    typeError: optional('string'),
    breedError: optional('string'),
    weightError: optional('string'),
}

export const defaultPets = {
    name:'',
    type: '',
    breed: '',
    weight: '',
    hasError: false,
    nameError:'',
    typeError: '',
    breedError: '',
    weightError: '',
}
